import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EquipmentTabFormService {

  private _consequenceRanking = signal<string | null>(null);
  public readonly consequenceRanking = this._consequenceRanking.asReadonly();

  private _taskFrequency = signal<string | null>(null);
  public readonly taskFrequency = this._taskFrequency.asReadonly();

  private _percentOverdue = signal<number | null>(null);
  public readonly percentOverdue = this._percentOverdue.asReadonly();

  private _assignedManagementAuthorizationLevel = signal<string | null>(null);
  public readonly assignedManagementAuthorizationLevel = this._assignedManagementAuthorizationLevel.asReadonly();

  setConsequenceRanking(value: string | null): void {
    this._consequenceRanking.set(value);
  }

  setTaskFrequency(value: string | null): void {
    this._taskFrequency.set(value);
  }

  setPercentOverdue(value: number | null): void {
    this._percentOverdue.set(value);
  }

  setAssignedManagementAuthorizationLevel(value: string | null): void {
    this._assignedManagementAuthorizationLevel.set(value);
  }
}
